// copy paste values witout importing for now
export const TILE_SIZE = 12 / 0.3048 // pixels, using imperial conversion rate to preserve render scale

export const GROUND_BASELINE_HEIGHT = 44
